import {aPIPaths, handleResponse, methods, requestJSON} from "../../Config";

export const ToolsServices = {
    generateMarkIdPayload,
    getCompanyNames,
    startOndatoIdentification
};

function generateMarkIdPayload(data) {
    return requestJSON(aPIPaths.post_GenerateMarkIdPayload, {
        method: methods.post,
        data: data
    }).then(handleResponse);
}

function getCompanyNames() {
    return requestJSON(aPIPaths.get_companyNames).then(handleResponse);
}

function startOndatoIdentification(data) {
    return requestJSON(aPIPaths.post_OndatoStartIdentification, {
        method: methods.post,
        data: data
    }).then(handleResponse);
}
